import {
  Autocomplete,
  TextField,
  InputLabel,
  Chip,
  Avatar,
  Tooltip,
} from "@mui/material";
import { toggleSnackbar } from "../../../RactiveVariables";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useState, useEffect } from "react";



export default function MemberView(props) {
  const { fields, append, website } = props;
  const [userList, setUserist] = useState([]);
console.log("fields",fields)
  useEffect(() => {
    setUserist(fields);
  }, [fields]);

  // function handleOnChange(value) {
  //   append({
  //     schUsersId: value[0]?._id,
  //     name: value[0]?.name,
  //     profileImage: value[0]?.profileImage,
  //     title: value[0]?.title,
  //     order:value[0].order
  //   });
  // }
  function handleOnChange(value) {
    const existingItemIndex = userList.findIndex(item => item.schUsersId === value[0]?._id);
  console.log(value,'value');
    if (existingItemIndex !== -1) {
      // Update existing item
      const updatedList = [...userList];
      updatedList[existingItemIndex] = {
        ...updatedList[existingItemIndex],
        sortOrder: value[0].sortOrder,
      };
      setUserist(updatedList);
    } else {
      // Append new item
      append({
        schUsersId: value[0]?._id,
        name: value[0]?.name,
        profileImage: value[0]?.profileImage,
        title: value[0]?.title,
        sortOrder: value[0].sortOrder
      });
    }
  }
  

  function getMemberIdArray() {
    return fields.map(element => element.name); // temporary fix, replace name with id
  }

  const filterOptions = (options) => {
    const idArray = getMemberIdArray();
    return options.filter(element => !idArray.includes(element?.name)); // temporary fix, replace name with id
  };
  
  function handleOnDragEnd(result) {
    if (!result.destination) return;
  
    const items = Array.from(userList);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
  
    // Update the order based on the new index
    const updatedItems = items.map((item, index) => ({
      ...item,
      sortOrder: index , // assuming order starts from 0
    }));
  
    setUserist(updatedItems);
  
    // Clear the current list in the parent component and append the updated items
    props.remove(); // Assuming you have a clear function to remove all previous items
    updatedItems.forEach((item) => {
      append({
        schUsersId: item.schUsersId,
        name: item.name,
        profileImage: item.profileImage,
        title: item.title,
        sortOrder: item.sortOrder,
      });
    });
  }
  
  
  return (
    <div className="card mb-4">
      <div className="card-title justify-content-between">
        <div className="d-flex">
          <img src="../../assets/images/Group.svg" alt="Group" /> Members
        </div>
        <a
          onClick={() => {
            if (!website || website === "") {
              toggleSnackbar({
                status: true,
                message: "Enter a website",
                variant: "error",
              });
            } else {
              props.setWebsiteFlag(true);
              props.setOpenAddMember(true);
            }
          }}
          className="addspeaker-btn"
        >
          <img src="../../assets/images/adduser.svg" alt="Add User" />
          Add School Member
        </a>
      </div>
      <div className="card-body speaker-select-outer">
        <div className="row">
          <div className="col-md-12 mb-3">
            <InputLabel className="form-label">
              Select members for School Public Profile
            </InputLabel>
            <Autocomplete
              multiple
              options={filterOptions(props?.data)}
              value={[]}
              getOptionLabel={(options) => options.name}
              filterSelectedOptions
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Type"
                />
              )}
              onChange={(e, value) => {
                handleOnChange(value);
              }}
            />
          </div>
          <div className="col-sm-12">
            <p className="speakers-head">Members</p>
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="users">
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {fields &&
                    userList?.sort((a, b) => a.sortOrder - b.sortOrder)
                      ?.map((item, index) => (
                        <Draggable draggableId={item.id} index={index} key={item.id}>
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                ...provided.draggableProps.style,
                                maxWidth: '800px', // or a specific pixel value
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                              }}
                              className="w-100 d-flex justify-content-between px-3 ps-2 pe-3 py-1 rounded border bg-light mt-3 mb-3"
                            >
                              <div className="d-flex align-items-center gap-2">
                                <Tooltip title="Drag to reorder">
                                <img className="me-2" src="../../assets/images/drag.svg" alt="Drag" />
                                </Tooltip>
                                <Avatar style={{ width: "20px", height: "20px" }} src={item.profileImage}>
                                  {item?.name?.[0].toUpperCase()}
                                </Avatar>
                                <div className="text-secondary">{item?.name}</div>
                              </div>
                              <div
                                className="cursor-pointer"
                                type="button"
                                onClick={() => props.remove(index)}
                              >
                                <img src="../../assets/images/close-drag.svg" alt="Close" />
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </div>
    </div>
  );
}
